import React from "react";
import { useSelector } from "react-redux";
import { selectIsSearchBtnClicked } from "../NavBar/NavBarSlice.js";

export const SearchBar = () => {
  const isSearchBtnClicked = useSelector(selectIsSearchBtnClicked);
  const isOpenSearch = isSearchBtnClicked;

  //Style Below
  const styleSearchBarContainer = {
    position: "relative",
    top: "40px",
    left: "4vw",
    height: "60px",
    width: "25vw",
    display: "flex",
    alignItems: "center",
  };
  const styleSearchForm = {
    display: "flex",
    alignItems: "center",
  };

  const styleInputForm = {
    width: "20vw",
    border: "none",
    height: "20px",
    padding: "20px 0 20px 5vw",
  };

  const styleSearchIcon = {
    position: "absolute",
    left: "2vw",
  };

  const styleSearchSubmitBtn = {
    position: "absolute",
    backgroundColor: "transparent",
    border: "none",
    padding: "0",
    right: "2vw",
  };

  return (
    <div
      className={`searchBarContainer ${
        isOpenSearch ? "searchBarOpen" : "searchBarHidden"
      }`}
      style={styleSearchBarContainer}
    >
      <form style={styleSearchForm}>
        <a className="navBar_option_item btn-search" style={styleSearchIcon}>
          <span style={{ display: "none" }}>Search</span>
          <svg className="svg-icon" viewBox="0 0 20 20" width="20px" height="20px">
            <path
              fill="#252525"
              d="M12.323,2.398c-0.741-0.312-1.523-0.472-2.319-0.472c-2.394,0-4.544,1.423-5.476,3.625C3.907,7.013,3.896,8.629,4.49,10.102c0.528,1.304,1.494,2.333,2.72,2.99L5.467,17.33c-0.113,0.273,0.018,0.59,0.292,0.703c0.068,0.027,0.137,0.041,0.206,0.041c0.211,0,0.412-0.127,0.498-0.334l1.74-4.23c0.583,0.186,1.18,0.309,1.795,0.309c2.394,0,4.544-1.424,5.478-3.629C16.755,7.173,15.342,3.68,12.323,2.398z M14.488,9.77c-0.769,1.807-2.529,2.975-4.49,2.975c-0.651,0-1.291-0.131-1.897-0.387c-0.002-0.004-0.002-0.004-0.002-0.004c-0.003,0-0.003,0-0.003,0s0,0,0,0c-1.195-0.508-2.121-1.452-2.607-2.656c-0.489-1.205-0.477-2.53,0.03-3.727c0.764-1.805,2.525-2.969,4.487-2.969c0.651,0,1.292,0.129,1.898,0.386C14.374,4.438,15.533,7.3,14.488,9.77z"
            ></path>
          </svg>
        </a>
        <input type="text" placeholder="SEARCH" style={styleInputForm} />
        <button type="submit" style={styleSearchSubmitBtn}>
          <span style={{ display: "none" }}>Submit</span>
          <svg className="svg-icon" viewBox="0 0 20 20" width="15px" height="15px">
            <path
              fill="#252525"
              d="M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0
	l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109
	c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483
	c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788
	S1.293,9.212,1.729,9.212z"
            ></path>
          </svg>
        </button>
      </form>
    </div>
  );
};
